var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 29,
    viewBox: "0 0 114 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100.541 28.3172L101.819 26.9584L104.869 23.7153L108.573 19.7761L111.758 16.3895C112.275 15.8398 112.801 15.2988 113.309 14.7405L113.332 14.7161C113.663 14.3649 113.645 13.7901 113.294 13.4598L111.935 12.1818L108.692 9.13186L104.753 5.42707L101.366 2.2421C100.816 1.72516 100.275 1.19905 99.717 0.691264L99.6925 0.668288C99.3536 0.349505 98.7484 0.344343 98.4363 0.706824C98.1213 1.07236 98.1115 1.62426 98.4748 1.96306L99.8337 3.24106L103.077 6.29105L107.016 9.99583L110.403 13.1808C110.952 13.6977 111.49 14.2269 112.052 14.7316L112.076 14.7546L112.037 13.4984L110.759 14.8573L107.709 18.1003L104.005 22.0396L100.82 25.4261C100.303 25.9758 99.7767 26.5168 99.2689 27.0751L99.2459 27.0996C98.9271 27.4385 98.922 28.0437 99.2845 28.3558C99.647 28.6709 100.199 28.6806 100.541 28.3172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M109.426 13.0015H7.87063C6.5018 13.0015 5.12106 12.9982 3.75222 13.0015H3.57368C1.70492 13.0015 -0.0805141 13.4609 0.0028063 14.0001C0.0861267 14.5426 1.57399 14.9986 3.57368 14.9986H105.129C106.498 14.9986 107.879 15.0019 109.248 14.9986H109.426C111.295 14.9986 113.081 14.5393 112.997 14.0001C112.902 13.4575 111.426 13.0015 109.426 13.0015Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/long-arrow.c76b344b5fd2164d16af0db93804788e.svg";
export { ForwardRef as ReactComponent };